import React, { useEffect } from "react";
import Menu from "../components/Menu";
import Seo from "../components/Seo";
import { trackEvent } from "../lib/analytics";
import { buildBusinessJsonLd, HOME_DESCRIPTION, HOME_TITLE } from "../lib/seo";

const HomePage = () => {
  useEffect(() => {
    trackEvent("view_pizzeria_menu", {
      section: "home"
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const observedSections = new Set();

    const registerSection = (section) => {
      if (!section || observedSections.has(section)) {
        return;
      }
      observedSections.add(section);
      observer.observe(section);
    };

    const registerExistingSections = () => {
      document.querySelectorAll(".menu-section").forEach((section) => {
        registerSection(section);
      });
    };

    registerExistingSections();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.classList.contains("menu-section")) {
            registerSection(node);
          }

          node.querySelectorAll?.(".menu-section").forEach((section) => {
            registerSection(section);
          });
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      mutationObserver.disconnect();
      observedSections.forEach((section) => observer.unobserve(section));
      observedSections.clear();
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <Seo title={HOME_TITLE} description={HOME_DESCRIPTION} path="/" jsonLd={buildBusinessJsonLd()} />
      <Menu />
    </>
  );
};

export default HomePage;
